import React from "react"

const DropdownIcon = () => {
    return (
        <svg width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9.5 1.00003C9.5 1.00003 6.55404 4.99999 5.49997 5C4.44589 5.00001 1.5 1 1.5 1" stroke="#606060" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
    )
}
export default DropdownIcon